import { createAction, props } from '@ngrx/store';
import { UploadedFileData } from '../domain/uploaded-file';

const feature = '[CXB File Upload]';

export const uploadCxBFile = createAction(`${feature} Upload file`, props<{ file: File; clientId: string }>());
export const uploadCxBFileSuccess = createAction(`${feature} Upload file success`, props<{ uploadedFileData: UploadedFileData }>());
export const uploadCxBFileFail = createAction(`${feature} Upload file error`, props<{ errorMessage: string }>());

export const deleteCxBFile = createAction(`${feature} Delete file`, props<{ fileId: string }>());
export const deleteCxBFileSuccess = createAction(`${feature} Delete file success`, props<{ fileId: string }>());
export const deleteCxBFileFail = createAction(`${feature} Delete file error`, props<{ errorMessage: string }>());
